var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2798 40.7799C43.2798 43.3399 42.5799 45.3199 41.2299 46.5999C39.9499 48.0099 38.0898 48.8399 36.2398 48.8399C32.4598 48.8399 29.2598 45.3799 29.2598 41.4199V26.9599C27.6598 29.5799 22.5398 32.7799 16.7798 32.7799C8.07985 32.7799 0.839844 25.5499 0.839844 16.9099C0.839844 8.2699 8.06985 0.969902 16.7798 0.969902C22.5398 0.969902 27.6598 4.2299 29.2598 6.8599V0.649902H32.6498V16.9099L32.0098 17.5499C32.0098 17.5499 32.6498 41.4199 32.0098 42.0599C32.6498 43.7199 34.1899 45.3899 36.2299 45.3899C37.2499 45.3899 38.0199 45.0699 38.7899 44.2999C39.4899 43.5299 39.8799 42.5699 39.8799 40.7799H43.2698H43.2798ZM16.7198 4.4299C9.73985 4.4299 4.23985 9.9299 4.23985 16.9099C4.23985 23.8899 9.73985 29.3899 16.7198 29.3899C23.6998 29.3899 29.2598 23.8899 29.2598 16.9099C29.2598 9.9299 23.7598 4.4299 16.7198 4.4299Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerQ);
export default __webpack_public_path__ + "static/media/LOWER_Q.c2693d0fa950c5a246966438964691d6.svg";
export { ForwardRef as ReactComponent };